import React from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";

import ChimneyProfileTracksByYearContainer from "./Containers/ChimneyProfileTracksByYearContainer";
import ChimneyProfileContainer from "./Containers/ChimneyProfileContainer";

import TrackBoxes from "../../Components/Elements/TrackBoxes";
import { getYears } from "~/utils/getYears";
import ProfileArchiveSelect from "./ProfileArchiveSelect";

const ChimneyProfileArchiveTracksPage = ({ match }) => (
  <ChimneyProfileTracksByYearContainer
    chimDir={match.params.chimDir}
    year={match.params.year}
    render={({ tracks, loading }) => {
      return (
        <div>
          <Row>
            <Col xs={12}>
              <ChimneyProfileContainer
                chimDir={match.params.chimDir}
                render={({ loading, error, profile }) => {
                  if (loading || error) return null;
                  console.log("🚀 ~ profile:", profile)
                  return (
                    <>
                      <Helmet>
                        <title>
                          {profile.full_name} Chimney tracks from {match.params.year} | Dream Chimney
                        </title>
                      </Helmet>
                      <h2 className="page-header">
                        <Link to={`/profile/${profile.chim_dir}`}>{profile.full_name} Chimney</Link>: Tracks posted in {match.params.year}
                      </h2>

                      <Row>
                        <Col sm={12} md={{ span: 6, offset: 6 }} lg={{ span: 3, offset: 9 }} style={{ paddingBottom: 10 }}>
                          <div style={{ textAlign: 'right' }}>

                            <ProfileArchiveSelect memberSince={profile.member_since} chimDir={profile.chim_dir} />
                          </div>
                        </Col>
                      </Row>

                    </>
                  );
                }}
              />
            </Col>
            <Col xs={6} className="text-right"></Col>
          </Row>

          <Row>
            <Col xs={12}>
              <TrackBoxes tracks={tracks} lg={3} md={3} />
            </Col>
          </Row>


        </div>
      );
    }}
  />
);

export default ChimneyProfileArchiveTracksPage;
